// import axios from '../../axios-orders'
import axios from 'axios'

// ------------------------------------ CounselingCenter fetch ------------------------------------
export const COUNSELING_CENTER_REQUEST = 'COUNSELING_CENTER_REQUEST'
export const counselingCenterRequest = () => ({
	type: COUNSELING_CENTER_REQUEST
})

export const COUNSELING_CENTER_RECEIVE = 'COUNSELING_CENTER_RECEIVE'
export const counselingCenterReceive = counselingCenter => ({
	type: COUNSELING_CENTER_RECEIVE,
	counselingCenter
})

export const COUNSELING_CENTER_ERROR = 'COUNSELING_CENTER_ERROR'
export const counselingCenterError = error => ({
	type: COUNSELING_CENTER_ERROR,
	error
})

export const counselingCenterFetch = (counselingCenterUsername, language, currency, timezone) => {
	return dispatch => {
		dispatch(counselingCenterRequest())

		axios.get(`https://panel.betterpro.app/api/counseling_center/${counselingCenterUsername}`,
			{
				headers: {
					'X-Accept-Language': language,
					'X-Currency': currency,
					'X-Timezone': timezone
				}

			})
			.then(response => {
				dispatch(counselingCenterReceive(response.data.content))
			})
			.catch(error => {
				dispatch(counselingCenterError())
			})
	}
}
